import { useEffect } from 'react'
import { Grid, Image } from 'semantic-ui-react'

import { TaxSeasonKickoffSurveyProps } from './YearEndKickoffSurvey'
import { Button, GridRowColumn, Text } from '@/componentsV1/BaseComponents'
import { makeGridConfig } from '@/componentsV1/BaseComponents/Grid'
import { TAX_SEASON_KICKOFF_SURVEY } from './TskTipsSideBar'
import { useReselector } from '@/utils/sharedHooks'
import {
  selectCurrentAnnualTaxDetails,
  selectCurrentAnnualTaxYear,
} from '@/features/admin/annual-tax-details/annualTaxDetails.selector'
import { getAnnualTaxFilingForYearSelector } from '../annualTaxFilings.selector'
import { useSaveAnnualTaxFilingFormData } from '../helpers'
import { defaultMessagesURL } from '@/features/zendesk/helpers'
import { convertUtcToLocalDate, DATE_FORMATS_LUXON } from '@/utils/dateHelpers'

const SCorpDisqualified = ({ goBack }: TaxSeasonKickoffSurveyProps) => {
  const taxDetails = useReselector(selectCurrentAnnualTaxDetails)
  const currentAnnualTaxYear = useReselector(selectCurrentAnnualTaxYear)
  const annualTaxFiling = useReselector(
    getAnnualTaxFilingForYearSelector,
    currentAnnualTaxYear
  )
  const saveTaxFiling = useSaveAnnualTaxFilingFormData(currentAnnualTaxYear)

  useEffect(() => {
    if (annualTaxFiling?.id) {
      saveTaxFiling({ taxSeasonSurveyNeedHelp: true })
    }
  }, [annualTaxFiling?.id, saveTaxFiling])

  return (
    <Grid>
      <GridRowColumn width={12}>
        <Grid>
          <GridRowColumn centerContent>
            <Image
              src="https://heard-images.s3.amazonaws.com/assets/plant-snake.svg"
              className="w-75 h-75 bg-transparent"
              alt="Plant Snake Short"
            />
          </GridRowColumn>
          <GridRowColumn {...makeGridConfig([10, 14], true)}>
            <Text as="h1" textAlign="center">
              We&apos;re not able to support your tax needs at this time
            </Text>
          </GridRowColumn>

          <GridRowColumn {...makeGridConfig([10, 14], true)}>
            <Text>
              The IRS deadline for 1120-S filing was{' '}
              <b>
                {convertUtcToLocalDate(taxDetails?.form_1120_s_irs_due_date)
                  ?.endOf('day')
                  .toFormat(DATE_FORMATS_LUXON.DISPLAY_LONG)}
              </b>{' '}
              We&apos;re unable to process new filings for this tax year. For
              help with your S corporation transition, please contact Support
              via Messages.
            </Text>
          </GridRowColumn>
          <GridRowColumn {...makeGridConfig([10, 14], true)} centerContent>
            <Button onClick={() => (window.location.href = defaultMessagesURL)}>
              Go to Messages
            </Button>
          </GridRowColumn>
          <GridRowColumn {...makeGridConfig([10, 14], true)} centerContent>
            <Button
              variant="secondaryLink"
              onClick={() => goBack(TAX_SEASON_KICKOFF_SURVEY.taxEntity)}
            >
              Go back
            </Button>
          </GridRowColumn>
        </Grid>
      </GridRowColumn>
    </Grid>
  )
}

export default SCorpDisqualified
